import { render } from "./HomeAdminTasks.vue?vue&type=template&id=40734594&scoped=true"
import script from "./HomeAdminTasks.vue?vue&type=script&lang=js"
export * from "./HomeAdminTasks.vue?vue&type=script&lang=js"

import "./HomeAdminTasks.vue?vue&type=style&index=0&id=40734594&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40734594"]])

export default __exports__